import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import CSSModules from 'helpers/CSSModulesUtil'
import { Flex } from 'reflexbox'
import { Button } from 'react-toolbox/lib/button'
import Body2 from 'components/typography/body2/index'
import Select from 'react-select'

import {
  applyQuery,
  updateQueryChanges
} from './actions'
import {
  querySourceSelector,
  queryInputSelector,
  reportsSelector
} from './selectors'
import styles from './styles.scss'

const mapStateToProps = (state) => {
  return {
    queryInput: queryInputSelector(state),
    querySource: querySourceSelector(state),
    reports: reportsSelector(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    applyQuery: (changes, reports) => dispatch(applyQuery(changes, reports)),
    updateQueryChanges: (type, value) => dispatch(updateQueryChanges(type, value))
  }
}

class DashboardQuery extends Component {

  onApply = () => {
    const {
      applyQuery,
      queryInput,
      reports,
    } = this.props

    const queries = [{
      type: "sku",
      input: queryInput('sku')
    }]
    applyQuery(queries, reports)
  }


  updateQueryChanges = (type) => {
    return (values) => this.props.updateQueryChanges(type, values)
  }

  render() {
    const {
      querySource,
      queryInput,
    } = this.props
    return (
      <Flex row='true' wrap styleName="dashboardQueryContainer">
        <Flex    
          column
          auto
          styleName='dashboardQuery'
        >
        <Body2 styleName='filterTitle'>Filter by Product SKUs</Body2>
          <Select
            options={querySource('sku')}
            value={queryInput('sku')}
            multi={true}
            onChange={this.updateQueryChanges('sku')}
            placeholder={`Select SKUs to begin...`}
          />
        </Flex>
        <Button label="Apply" styleName='button' onClick={this.onApply} raised primary/>
    </Flex>
    )
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withStyle = CSSModules(styles)

export default compose(
  withConnect,
  withStyle
)(DashboardQuery)
